export default (theme) => ({
  container: {
    marginBottom: 20
  },
  heading: {
    fontSize: '28px',
    fontWeight: '500'
  },
  subheading: {
    marginTop: 10
  },
});
